__turbopack_context__.v({
  "bubbleBox": "ProgressBarWithBubble-module__grhQZq__bubbleBox",
  "bubbleTail": "ProgressBarWithBubble-module__grhQZq__bubbleTail",
  "labelRow": "ProgressBarWithBubble-module__grhQZq__labelRow",
  "progressBar": "ProgressBarWithBubble-module__grhQZq__progressBar",
  "progressBase": "ProgressBarWithBubble-module__grhQZq__progressBase",
  "progressWrapper": "ProgressBarWithBubble-module__grhQZq__progressWrapper",
  "wrapper": "ProgressBarWithBubble-module__grhQZq__wrapper",
});
